import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Compiler, Component, ComponentFactory, ComponentRef, ModuleWithComponentFactories, NgModule, OnInit, ViewChild, ViewContainerRef
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { LazyLoadScriptService } from '../../lazy_load_script_service';
import { PageService } from '../../services';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  @ViewChild('container', { static: true, read: ViewContainerRef }) container: ViewContainerRef;

  private componentRef: ComponentRef<{}>;
  constructor(
    private service: PageService,
    public sanitizer: DomSanitizer,
    private compiler: Compiler,
    public cdRef: ChangeDetectorRef,
    private meta: Meta,
    private title: Title,
    private lazyLoadService: LazyLoadScriptService
  ) { 
    this.meta.addTags([
      {name: 'description', content: 'Home page of UN - One HR - Salary Survey'},
      {name: 'author', content: 'One HR, Salary Survey'},
      {name: 'keyword', content: 'One HR, Salary Survey'}
    ]);
    this.setTitle('UN - Home Page');
  }
  public setTitle(newTitle: string){
    this.title.setTitle(newTitle); 
  }
  slug = 'home';


  template: string;
  carousel: string;
  public ngOnInit() {
    this.service.get(this.slug).subscribe((response: any) => {
      var str = response.data.html?.map(ele => ele.html).join("");
      this.template = str;
      this.carousel = `
      <div *ngIf="videoItems.length > 0" class="landing-section" style="margin: auto; position: relative; box-shadow: 0 0 7px black; border-radius: 5px;">
        <div id="carouselExampleControls" class="carousel slide p-0" data-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <vg-player (onPlayerReady)="videoPlayerInit($event)">
                <vg-overlay-play></vg-overlay-play>
                <vg-buffering></vg-buffering>

                <vg-scrub-bar>
                  <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                  <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                </vg-scrub-bar>

                <vg-controls>
                  <vg-play-pause></vg-play-pause>

                  <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
                  <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>

                  <vg-scrub-bar style="pointer-events: none;"></vg-scrub-bar>

                  <vg-mute></vg-mute>
                  <vg-volume></vg-volume>

                  <vg-fullscreen></vg-fullscreen>
                </vg-controls>

                  <video #media [vgMedia]="media" id="player_{{activeIndex}}" [src]="currentVideo?.filePath"
                    [type]="currentVideo?.fileType" preload="auto">
                  </video>
                </vg-player>
              </div>
            </div>

            <a *ngIf="videoItems && videoItems.length > 1" class="carousel-control-prev carousel-control left" href="#carouselExampleControls" role="button"
              data-slide="prev" style="height:75%" (click)="prevVideo()">
              <span class="fa fa-chevron-left" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a *ngIf="videoItems && videoItems.length > 1" class="carousel-control-next carousel-control right" href="#carouselExampleControls" role="button"
              data-slide="next" style="height:75%" (click)="nextVideo()">
              <span class="fa fa-chevron-right" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      `;
      this.compileTemplate();
    });
  }

  compileTemplate() {
    let metadata = {
      selector: `runtime-component-sample`,
      template: this.template + this.carousel,
      changeDetection: ChangeDetectionStrategy.OnPush
    };

    let factory = this.createComponentFactorySync(this.compiler, metadata, null, this);

    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
    this.componentRef = this.container.createComponent(factory);
    this.lazyLoadService.loadScript('/assets/js/onehr.js').subscribe(_ => {

    });
  }


  private createComponentFactorySync(compiler: Compiler, metadata: Component, componentClass: any, THIS: any,): ComponentFactory<any> {
    const cmpClass = componentClass || class RuntimeComponent {
      customOptions: OwlOptions = {
        loop: true,
        mouseDrag: false,
        touchDrag: false,
        center: true,
        pullDrag: false,
        dots: false,
        navSpeed: 700,
        navText: ['Previous', 'Next'],
        responsive: {
          0: {
            items: 1
          },
          400: {
            items: 2
          },
          740: {
            items: 3
          },
          940: {
            items: 4
          }
        },
        nav: true
        // navText: ['<', '>'],
      }
      // videoItems = [
      //   {
      //     name: 'First Video',
      //     src: 'https://www.html5rocks.com/en/tutorials/video/basics/devstories.webm',
      //     type: 'video/mp4'
      //   },
      //   {
      //     name: 'Second Video',
      //     src: 'http://static.videogular.com/assets/videos/videogular.mp4',
      //     type: 'video/mp4'
      //   },
      //   {
      //     name: 'Third Video',
      //     src: 'http://static.videogular.com/assets/videos/big_buck_bunny_720p_h264.mov',
      //     type: 'video/mp4'
      //   }
      // ];
      activeIndex = 0;
      // currentVideo = this.videoItems[this.activeIndex];
      data;
      videoItems: any;
      currentVideo: any;

      public ngOnInit() {
        THIS.service.getHomeMedia('homemedia').subscribe((media: any) => {
          if (media.data.length > 0) {
            this.videoItems = media.data;
            if (this.videoItems) {
              this.currentVideo = this.videoItems[this.activeIndex];
            }
          }
        });
      }

      videoPlayerInit(data) {
        this.data = data;
        this.data.getDefaultMedia().subscriptions.loadedMetadata.subscribe(this.initVdo.bind(this));
        this.data.getDefaultMedia().subscriptions.ended.subscribe(this.nextVideo.bind(this));
      }

      initVdo() {
        // this.data.play(); // Auto-play
      }

      prevVideo() {
        if (this.activeIndex > 0) {
          this.activeIndex--;
          this.currentVideo = this.videoItems[this.activeIndex];
          this.data.pause();
        }
      }

      nextVideo() {
        this.activeIndex++;
        if (this.activeIndex === this.videoItems.length) {
          this.activeIndex = 0;
        }
        this.currentVideo = this.videoItems[this.activeIndex];
        this.data.pause();
      }
    };
    const decoratedCmp = Component(metadata)(cmpClass);
    const decoratedNgModule = NgModule({
      imports: [
        CommonModule,
        CarouselModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        VgCoreModule,
      ], declarations: [decoratedCmp]
    })(cmpClass);

    const module: ModuleWithComponentFactories<any> = compiler.compileModuleAndAllComponentsSync(decoratedNgModule);
    return module.componentFactories.find(f => f.componentType === decoratedCmp);
  }
}